import React, { useState } from 'react';

// Classname
import clsx from 'clsx';

// components
import Button from 'components/UiKit/Button';
import DebounceInput from 'components/UiKit/DebounceInput';
import FormatOptionLabel from 'components/FormatOptionLabel';

// Lib
import { shallowEqual } from 'react-redux';
import { useAppSelector, useAppDispatch } from 'lib/hooks/useDispatch';

// Actions
import * as actionsCreator from 'pages/ChemicalProbes/reducer';
import { showMessage } from 'reducers/messages';

// Constants
import { messageNotEmptyValue } from 'pages/LibrariesCompounds/LibrariesCompounds';

// Interface
interface ISearch {
	className?: string;
}

export const Search: React.FC<ISearch> = (props) => {
	const { className = '' } = props;
	const dispatch = useAppDispatch();

	const { input} = useAppSelector(
		(store) => {
			return {
				data: store.chemicalProbes.data,
				input: store.chemicalProbes.input,
				loading: store.chemicalProbes.loading
			};
		},
		shallowEqual
	);

	const [isShow, setIsShow] = useState<boolean>(false);

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e?.key === 'Enter') {
			e.preventDefault();
			dispatch(actionsCreator.handlerSearch());
		}
	};

	const handlerSubmit = () => {
		if (!input?.length) {
			dispatch(showMessage(messageNotEmptyValue));
			return false;
		}

		dispatch(actionsCreator.handlerSearch());
		setIsShow(true);
	};
	// React.ChangeEvent<HTMLInputElement> e.target.value
	const onChangeInput = (value: string) => {
		dispatch(actionsCreator.handlerChangeInput(value));
	};

	const leftIconAction = () => {
		handlerSubmit();
	};

	const handlerShowAll = () => {
		dispatch(actionsCreator.handlerShowAllData());
		dispatch(actionsCreator.handlerChangeInput(''));
		setIsShow(false);
	};

	const cn = clsx(
		'chemical-probes__search flex flex-ai-center flex-jc-start flex-direction-column-mobile',
		className
	);

	return (
		<div className={cn} id="chemical-probes-search">
			<DebounceInput
				isWhite
				isLeftIcon

				value={input || ''}
				// isControlledOut

				onChange={onChangeInput}
				onKeyDown={handleKeyDown}
				Children={FormatOptionLabel}
				leftIconAction={leftIconAction}
				classNameWrapper="input-debounce__white"
				placeholder="ID, CAS, Name, Target, Target action"
			/>

			<Button
				variable="info"
				color="white"
				label="Search"
				type="button"
				typePadding="middle"
				onPress={handlerSubmit}
				className="ml30 search-screen__search-btn"
			/>

			{isShow && <Button
				color="white"
				label="Show all"
				className="ml10"
				variable="outline"
				onPress={handlerShowAll}
			/>}
		</div>
	);
};

export default Search;
